import { useRef } from "react";
import { Skeleton } from "primereact/skeleton";
import LaddaButton from "../buttons/laddaButton";
import { icons } from "../../constants";

const FileUploadButton = ({
  onFileChange,
  buttonText = "Subir archivo (PDF o imagen)",
  path = "",
  fileType = null,
  disabled = false,
  isViewer = false
}) => {
  const fileInputRef = useRef(null);

  const looksLikePDFByPath = !!path && /\.pdf(\?|#|$)/i.test(path);
  const isPDF = fileType ? fileType === "pdf" : looksLikePDFByPath;
  const hasPreview = Boolean(path);

  const handleInputClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const handleChange = (e) => {
    const f = e.target?.files?.[0] || null;
    onFileChange && onFileChange(f);
  };

  const handleClear = () => {
    onFileChange && onFileChange(null);
  };

  return (
    <div>
      {hasPreview ? (
        <div className="mt-10">
          {isPDF ? (
            <object
              key={path}
              data={path}
              type="application/pdf"
              width="100%"
              height="420px"
              style={{ borderRadius: 10, border: "none" }}
            >
              <p>
                No se pudo previsualizar el PDF.{" "}
                <a href={path} target="_blank" rel="noreferrer">
                  Ábrelo en una pestaña nueva
                </a>
                .
              </p>
            </object>
          ) : (
            <img
              key={path}
              src={path}
              alt="Previsualización"
              style={{
                width: "100%",
                height: "420px",
                objectFit: "contain",
                borderRadius: 10
              }}
            />
          )}
        </div>
      ) : (
        <Skeleton
          className="mt-10"
          height="300px"
          width="100%"
          borderRadius="10px"
        />
      )}

      <input
        type="file"
        accept="image/*,application/pdf"
        hidden
        ref={fileInputRef}
        onChange={handleChange}
      />

      {!isViewer && (
        <div
          className="HContainer j-center no-print"
          style={{ gap: 10, marginTop: 10 }}
        >
          {!disabled && (
            <LaddaButton
              variant="contained"
              width="auto"
              fontSize="12px"
              height="40px"
              borderColor="#6A6AD8"
              color="#6A6AD8"
              backgroundColor="#ffffff"
              onClick={handleInputClick}
            >
              <img
                className="btn-icon"
                src={icons.attach_file}
                alt="icon"
                style={{ marginRight: 10 }}
              />
              {buttonText}
            </LaddaButton>
          )}

          {hasPreview && !disabled && (
            <LaddaButton
              width="40px"
              fontSize="12px"
              height="40px"
              variant="contained"
              backgroundColor="#3f3fd9"
              onClick={handleClear}
              borderRadius="20px"
              title="Quitar archivo"
            >
              <img
                className="btn-icon-mini"
                src={icons.closeWhite}
                alt="icon"
              />
            </LaddaButton>
          )}
        </div>
      )}
    </div>
  );
};

export default FileUploadButton;
